/**
 * 展示上传弹窗，公共组件
 */
import Decorate from '@tencent/spaui-decorate'
import BindAppDialog from 'biz-components/BindAppDialog'

export const dialog = new Decorate(BindAppDialog)

export const handleClose = () => {
    dialog.setProps({
        show: false,
    })
}

export const showDialog = props => {
    dialog.setProps({
        show: true,
        onClose: handleClose,
        onCancel: handleClose,
        ...props,
        children: null,
    })
}
export default showDialog
